import React from "react";
import withTranslator from "../Translator/withTranslation";

class TaglineComponent extends React.Component {
    constructor(props) {
        super(props);
    }
        
    render() {
        var taglineKey = this.props.mobile ? 'storybrand_line_mobile' : 'relaxprivatedreamvilla';
        const { t } = this.props;

        return (
            <div className={this.props.className} dangerouslySetInnerHTML={{__html: 
                t(taglineKey)
            }} />
        );
    }
}

export const Tagline = withTranslator(TaglineComponent);